// Coarse-grain "N units ago" for sync-freshness labels (cache statuses, the
// meshes Synced column). Distinct from formatTimestampAge, which is
// digest-freshness-specific (minute grain, fresh/late/silent buckets) — this
// one goes up to days and treats null as 'Never'.
export function timeAgo(dateString: string | null): string {
  if (!dateString) return 'Never';
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (seconds < 60) return 'Just now';
  const unit = (n: number, name: string) => `${n} ${name}${n !== 1 ? 's' : ''} ago`;
  if (seconds < 3600) return unit(Math.floor(seconds / 60), 'minute');
  if (seconds < 86400) return unit(Math.floor(seconds / 3600), 'hour');
  return unit(Math.floor(seconds / 86400), 'day');
}
